

























import Vue from 'vue';
import { IIcons } from '@/common/interfaces/index.interface';
import { IProductCategory } from '@/common/interfaces/products.interface';
import CustomButton from '../layout/buttons/CustomButton.vue';
import ProductsOverviewViewToggle from './ProductsOverviewViewToggle.vue';
import URLHelper from '../../helpers/URLHelper';
import config from '../../../config';

interface IProductsOverviewHeaderComponent {
  isOffersPage: boolean;
}

export default Vue.extend({
  name: `ProductsOverviewHeader`,
  components: { CustomButton, ProductsOverviewViewToggle },
  data(): IProductsOverviewHeaderComponent {
    return {
      isOffersPage: false,
    };
  },
  props: {
    categories: {
      required: true,
      type: Array as () => IProductCategory[],
    },
    icons: {
      required: true,
      type: Object as () => IIcons,
    },
    mode: {
      required: true,
      type: String,
    },
  },
  mounted(): void {
    const { slug } = URLHelper.parsedUrlObject;
    this.isOffersPage = config.products.specialShopCategoriesURLSlugs.offers.includes(slug);
  },
});
